import React from "react";
import styles from "./content.module.scss";
import { Route, Switch } from "react-router";
import ReportsBar from "../sections/sideBars/reportsBar";
import ReportPage from "../ReportPage/ReportPage";
import { HistoryReports, SavedReports } from "../sections/contentBlocks/contentBlocksContainer";

const ReportsContent = (props) => {
  return (
    <Switch>
      <Route exact path={["/reports", "/reports/:type", "/history-reports", "/saved-reports"]}>
        <div className={props.isSideBarOpen ? styles.content : styles.content_closedBar}>
          <div className={styles.container_sideBar}>
            <ReportsBar />
          </div>

          <div className={styles.container_sideContent}>
            <Switch>
              <Route exact path={["/reports", "/reports/:type"]} component={ReportPage} />
              <Route exact path="/history-reports" component={HistoryReports} />
              <Route exact path="/saved-reports" component={SavedReports} />
            </Switch>
          </div>
        </div>
      </Route>
    </Switch>
  );
};

export default React.memo(ReportsContent);
